import React from "react";
import "./footer.css";

const Footer = () => {
  const handleCallNow = () => {
    window.location.href = "tel:+250780316256"; // Update with the correct phone number
  };

  return (
    <footer className='modern-footer'>
      <div className='container'>
        <div className='footer-grid'>
          <div className='footer-section footer-logo'>
            <img src='../images/logo-light.png' alt='Company Logo' />
            <p>Premium Aluminium & Partition Solutions in Rwanda. Transforming spaces with quality and innovation.</p>
          </div>
          
          <div className='footer-section footer-contact'>
            <h3>Contact Us</h3>
            <p>📍 Kigali, Rwanda</p>
            <p>📞 <a href='tel:+250780316256'>+250780316256</a></p>
            <p>📧 <a href='mailto:mutabazizacky@gmail.com'>mutabazizacky@gmail.com</a></p>
            <button className='btn-contact' onClick={handleCallNow}>Call Now</button>
          </div>
          
          <div className='footer-section footer-social'>
            <h3>Follow Us</h3>
            <div className='social-links'>
              <a href='https://facebook.com' target='_blank' rel='noopener noreferrer'>Facebook</a>
              <a href='https://instagram.com' target='_blank' rel='noopener noreferrer'>Instagram</a>
              <a href='https://twitter.com' target='_blank' rel='noopener noreferrer'>Twitter</a>
            </div>
          </div>
          
          <div className='footer-section footer-newsletter'>
            <h3>Subscribe</h3>
            <p>Stay updated with our latest news and offers.</p>
            <div className='input-container'>
              <input type='email' placeholder=' ' />
              <button onClick={() => window.location.href = "https://g.page/r/CYJcdLp6d9xrEAE/review"}>Subscribe</button>
            </div>
          </div>
        </div>
      </div>
      <div className='legal center'>
        <span>© {new Date().getFullYear()}. Aluminium & Partition Rwanda. Designed by Ally Mutabazi.</span>
      </div>
    </footer>
  );
};

export default Footer;
